import React from "react";

import SalesLandingLayout from "../layouts/SalesLandingLayout";
import SalesLandingStep1 from "./components/step1/SalesLandingStep1";
import SalesLandingStep2 from "./components/step2/SalesLandingStep2";
import SalesLandingStep3 from "./components/step2/SalesLandingStep3";

export const SalesLandingRoutes = () => {
    return (
        <React.Fragment>
            <SalesLandingLayout exact path="/sales_landing" component={SalesLandingStep1} />
            <SalesLandingLayout exact path="/sales_landing/step2" component={SalesLandingStep2} />
            <SalesLandingLayout exact path="/sales_landing/step2/step3" component={SalesLandingStep3} />
        </React.Fragment>
    );
};
